/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {ILogLevelLogFilter, LogLevelLogFilter} from './LogLevelLogFilter';
import {oneOf} from 'types/oneOf';
import {ITextLogFilter, TextLogFilter} from './TextLogFilter';
import {ITimeLogFilter, TimeLogFilter} from './TimeLogFilter';
import {ITransactionLogFilter, TransactionLogFilter} from './TransactionLogFilter';
import {enums} from 'types/enums';

export const LogFilters = yup
   .originArray()
   .of(oneOf([LogLevelLogFilter, TextLogFilter, TimeLogFilter, TransactionLogFilter]))
   .transform(function (value, origin) {
      // console.debug(value, origin);
      if (this.isType(value)) return value;

      return convertToLogFilter(origin);
   });
export type ILogFilters = (
   | ILogLevelLogFilter
   | ITextLogFilter
   | ITimeLogFilter
   | ITransactionLogFilter
)[];

export const LogFilterFormType = yup
   .object({
      minimumLevel: yup
         .string()
         .oneOf(enums.minimumLevel.keys)
         .default(enums.minimumLevel.enum.LOG_DEBUG),
      filterType: yup
         .string()
         .oneOf(enums.filterType.keys)
         .default(enums.filterType.enum.TRANS_FILTER),
      text: yup.string(),
      transNames: yup.array().of(yup.string()),
   })
   .transform(function (value, origin) {
      // console.debug(value, origin);
      if (this.isType(value)) return value;
      return convertFromLogFilter(origin);
   });
export type ILogFilterFormType = yup.InferType<typeof LogFilterFormType>;

export function convertToLogFilter(formFilter: ILogFilterFormType) {
   const filters = [
      LogLevelLogFilter.cast({
         minimumLevel: formFilter.minimumLevel,
      }),
   ] as ILogFilters;

   if (formFilter.filterType === enums.filterType.TRANS_FILTER) {
      filters.push(
         TransactionLogFilter.cast({
            transNames: formFilter.transNames,
         })
      );
   } else if (formFilter.text) {
      filters.push(
         TextLogFilter.cast({
            text: formFilter.text,
         })
      );
   }

   // console.debug(filters);
   return filters;
}

function convertFromLogFilter(filters: ILogFilters) {
   const filterForm = {} as ILogFilterFormType;
   filters?.forEach((f) => {
      switch (f.filterType) {
         case enums.filterType.enum.LOG_LEVEL_FILTER:
            filterForm.minimumLevel = (f as ILogLevelLogFilter).minimumLevel;
            break;
         case enums.filterType.enum.TEXT_FILTER:
            filterForm.filterType = f.filterType;
            filterForm.text = (f as ITextLogFilter).text;
            break;
         case enums.filterType.enum.TRANS_FILTER:
            filterForm.filterType = f.filterType;
            filterForm.transNames = (f as ITransactionLogFilter).transNames;
            break;
      }
   });

   return filterForm;
}
